import React from 'react';
import PhotoItem from './PhotoItem';
import '../styles/PhotoGallery.css';

const PhotoGallery = ({ photos, onPhotoClick }) => {
  return (
    <div className="photo-gallery">
      <div className="gallery-grid">
        {photos.map((photo, index) => (
          <PhotoItem
            key={index}
            photo={photo}
            onClick={() => onPhotoClick(photo)}
          />
        ))}
      </div>

      {photos.length === 0 && (
        <div className="no-photos">
          <p>暂无照片</p>
          <p>请在 public/assets/images/ 目录下添加照片</p>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;